import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import ViewOrg from '../../components/organizations/view/ViewOrg'
import { getSingleOrganization } from '../../state/actions/organizations/'
import {
  getOrganization,
  getOrganizationFetching,
  getOrganizationFetchingError
} from '../../state/reducers/organizations'
import { IStoreState } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<any>) {
  return {
    organization: getOrganization(state, ownProps.match.params.id),
    fetching: getOrganizationFetching(state),
    error: getOrganizationFetchingError(state)
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getSingleOrganization: (id: string) => dispatch(getSingleOrganization(id))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewOrg)



// WEBPACK FOOTER //
// ./src/containers/organizations/ViewOrg.ts